import { INVOICE_DUE_SOON_DAYS } from '../../../../constants/default.const';

export type InvoiceDueStatus = 'overdue' | 'dueSoon' | null;

const msPerDay = 24 * 60 * 60 * 1000;

export function getInvoiceDueStatus(invoiceDueDate?: string | null, amountDue?: number | null): InvoiceDueStatus {
    // A fully paid (or credit) invoice is never overdue/due-soon, regardless of its DueDate.
    if (amountDue != null && amountDue <= 0) {
        return null;
    }

    if (!invoiceDueDate) {
        return null;
    }

    const dueDate = new Date(invoiceDueDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set time to midnight for accurate comparison
    dueDate.setHours(0, 0, 0, 0); // Set time to midnight for accurate comparison

    if (dueDate < today) {
        return 'overdue';
    }

    // Compare whole calendar days: fixed-ms arithmetic drifts by ±1h across a DST boundary.
    const daysUntilDue = Math.round((dueDate.getTime() - today.getTime()) / msPerDay);
    if (daysUntilDue <= INVOICE_DUE_SOON_DAYS) {
        return 'dueSoon';
    }

    return null;
}
